<template>
  <b-modal
    :visible="value"
    centered
    hide-header
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
    @change="$emit('input', $event)"
  >
    <div class="text-center py-4">
      <component :is="icon" scale="2.4" :class="iconClass" />
      <h3 class="font-weight-bold mt-3">{{ title }}</h3>
      <p v-for="(line, idx) in lines" :key="idx" class="text-muted mb-1">
        {{ line }}
      </p>

      <slot></slot>

      <b-button variant="primary" class="mt-4" @click="$emit('confirm')">
        {{ buttonText }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
// Outcome modal for the Wannasorn add-member flow: same shell for both the success and the error
// state, with the extra body (name / student id rows) supplied through the default slot.
export default {
  props: {
    value: { type: Boolean, default: false },
    variant: { type: String, default: "success" }, // "success" | "danger"
    title: { type: String, default: "" },
    lines: { type: Array, default: () => [] },
    buttonText: { type: String, default: "ตกลง" },
  },
  computed: {
    isSuccess() {
      return this.variant === "success";
    },
    icon() {
      return this.isSuccess ? "b-icon-check-circle" : "b-icon-x-circle";
    },
    iconClass() {
      return this.isSuccess ? "text-success" : "text-danger";
    },
  },
};
</script>
